import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useIsMobile } from '@scramble/hooks';
import { Badge, Button, RadioButton } from '@scramble/ui';
import { Preloader } from '@/components/Preloader';
import IconBank from '@scramble/design-system/icons/bank.svg';
import { useGetWithdrawInfo } from '@/query/queries/cash/useGetWithdrawInfo';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

const id = MODAL_IDS.withdraw_select_modal;

export const WithdrawSelectModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal {...props} />;
};

export const Modal = ({ selected, onChange }) => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetWithdrawInfo();
  const isMobile = useIsMobile();
  const { closeModal } = useModal();
  const navigate = useNavigate();

  const accounts = data?.external_accounts || [];

  let content;

  if (isLoading || !data) {
    content = (
      <div className={s.modal}>
        <div className={s.header}>
          <h1 className={s.title}>{t('modal:withdraw_select_modal.title')}</h1>
        </div>
        <div className={s.content}>
          <div className={s.content_inner}>
            <Preloader className={s.preloader} />
          </div>
        </div>
      </div>
    );
  } else {
    content = (
      <div className={s.modal}>
        <div className={s.header}>
          <h1 className={s.title}>{t('modal:withdraw_select_modal.title')}</h1>
        </div>
        <div className={s.content}>
          <div className={s.content_inner}>
            {accounts.map(item => (
              <div
                className={s.card}
                key={item.account_number}
                onClick={() => {
                  onChange(item);
                  closeModal(id);
                }}
              >
                <div className={s.card_content}>
                  <img src={IconBank} width={20} height={20} alt="icon" />
                  <div>
                    <div className={s.card_title}>{item.account_number}</div>
                    <div className={s.card_summary}>
                      <Badge
                        label={t('modal:withdraw_select_modal.approved')}
                        type="success"
                        appearance="tonal"
                        size="small"
                      />
                      <span>
                        {t('withdraw:withdrawal_destination.num_days', {
                          count: '2-4',
                        })}
                      </span>
                      <span>{t('withdraw:withdrawal_destination.no_fee')}</span>
                    </div>
                  </div>
                </div>
                <RadioButton
                  name="destination"
                  className={s.card_radio}
                  checked={item.account_number === selected?.account_number}
                  onChange={() => null}
                />
              </div>
            ))}
          </div>
        </div>
        <div className={s.footer}>
          <Button
            label={t('modal:withdraw_select_modal.add_bank_account')}
            theme="neutral"
            appearance="filled"
            size="lg"
            onClick={() => {
              navigate(APP_LINKS.bankAccounts);
            }}
          />
        </div>
      </div>
    );
  }

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
